import {Api} from '../utils';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RequestsHandler} from './requests.service';
import {Observable} from 'rxjs/Observable';
import {Statistics} from '../model/statistics.interface';
import {CookieService} from "ngx-cookie";
import {User} from "@models/user.interface";
import 'rxjs/add/operator/map';

@Injectable()
export class AdminService {
  constructor(
    private http: HttpClient,
    private api: Api,
    private handler: RequestsHandler,
    private _cookieService: CookieService,
    ) {}

  getStatistics(): Observable<Statistics> {
    return this.http.get(this.api.getUrl('admin/statistics'), {headers: this.handler.headers()})
      .catch((err: any) => {
        return Observable.throw(new Error(err));
      });
  }

  loginAsUser(id) {
    return this.http.post(
      this.api.getUrl(`admin/users/${id}/login`),
      null, {headers: this.handler.headers()}
    ).map((response: User) => {
      const token: string = response && response.token;

      if (token) {
        this._cookieService.put('auth_token', token);
        return response;
      } else {
        return false;
      }
    }).catch((err: any) => {
      return Observable.throw(err);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/admin.service.ts